// extracted by mini-css-extract-plugin
export default {"card":"card__ZDI1Y","hed":"hed__ZmYwN","note":"note__NzlmM","link":"link__ZjQyM"};